import MuiSvgIcon from '../MuiIcon';

const Play = (props) => {
  const { innerFillColor, ...rest } = props;
  const innerFill = innerFillColor || 'var(--color-i-white)';
  return (
    <MuiSvgIcon {...rest} viewBox="0 0 48 48">
      <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" />
      <path
        d="M31.2641 25.5181C32.256 24.7506 32.256 23.2532 31.2641 22.4857C28.2666 20.1663 24.9194 18.3381 21.3478 17.0697L20.6954 16.8379C19.4471 16.3946 18.1286 17.2391 17.9596 18.5277C17.4874 22.1279 17.4874 25.8759 17.9596 29.4761C18.1286 30.7647 19.4471 31.6092 20.6954 31.1659L21.3478 30.9341C24.9194 29.6657 28.2666 27.8375 31.2641 25.5181Z"
        fill={innerFill}
      />
    </MuiSvgIcon>
  );
};

export default Play;
